module.exports = __webpack_public_path__ + "img/clean.3b5bf312.webp";